import './index.less';


// WEBPACK FOOTER //
// ./ecology9/wea-table-editable/style/index.js